<template>
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group">
    <button
      aria-label="Sort by Distance"
      class="mapboxgl-ctrl-icon"
      @click="handleClick" 
    >
    <i role="status" class="fas fa-spinner fa-spin"
      v-if="loading"
      style="transform: scale(1.25);"
      :style="`color: ${activeColor}`"
    ></i>
    <i class="fas fa-route" 
      v-else
      style="transform: scale(1.25);"
      :style="`color:${isGeolocationOn ? activeColor : ''};`"
    ></i>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'sightmap-nearby-btn',
  uit() {
    return [
      ['action', ['sortByDistance']]
    ]
  },
  computed: {
    ...mapState({
      isGeolocationOn: state => state.geolocation.isGeolocationOn,
      loading: state => state.geolocation.loading,
    }),
    activeColor: function() {
      return this.blackAndWhite ? 'rgb(157, 157, 157)' : 'rgb(58, 177, 227)'
    }
  },
  methods: {
    handleClick: function() {
      this.isGeolocationOn 
        ? this.$store.dispatch('geolocation/turnOffGeolocation')
        : this.$store.dispatch('geolocation/turnOnGeolocation');
    }
  }
}
</script>